module.exports = __webpack_public_path__ + "img/2022956-44-9.9057f81e.png";